import React from 'react';
import { StyleSheet, Text, Pressable } from 'react-native';
import Theme from 'Theme';
import PropTypes from 'prop-types';

const ACTIVE_BORDER_THICKNESS = 3;

const styles = StyleSheet.create({
    button: {
        height: 72,
        marginHorizontal: 5,
        flexDirection: 'column',
        justifyContent: 'center',
        borderBottomWidth: ACTIVE_BORDER_THICKNESS
    },
    buttonText: {
        fontFamily: Theme.boldFont,
        color: Theme.primaryTextColor,
        fontSize: 16,
        marginHorizontal: 5,
        marginTop: ACTIVE_BORDER_THICKNESS + ACTIVE_BORDER_THICKNESS / 2
    }
});

class MenuButton extends React.Component {
    constructor() {
        super();
        this.state = {};
    }

    render() {
        const { isActive, onPress, title, testID } = this.props;

        return (
            <Pressable
                style={[styles.button, { borderBottomColor: isActive ? 'white' : 'transparent' }]}
                onPress={() => {
                    onPress();
                }}
                testID={testID}
            >
                <Text style={styles.buttonText}>{title}</Text>
            </Pressable>
        );
    }
}
MenuButton.propTypes = {
    isActive: PropTypes.bool,
    onPress: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    testID: PropTypes.string
};

MenuButton.defaultProps = {
    isActive: true,
    testID: undefined
};

export default MenuButton;
